import React from 'react';

const ModeloFollowUpContext = React.createContext();

export default ModeloFollowUpContext;
